import React from 'react'
import { LoadingButton } from '@mui/lab'
import {
  useCreateCopyProgramMutation,
  useGetDitsQuery,
} from '@/components/Organisms/DIT/service'
import { useParams } from 'react-router-dom'
import { useAppSelector } from '@/hooks'
import { ditSliceSelectors } from '@/components/Organisms/DIT/store'
import { LoaderFullScreen } from '@/ui'
import DialogChanges from '@/components/Dialog/DialogChanges'
import { notifySuccess } from '@/components'
import { getLastProgramNumber } from '@/components/Organisms/DIT/helpers'

const BtnMakeCopy: React.FC<{ newName: string }> = ({ newName }) => {
  const { id } = useParams()
  const activeProgramId = useAppSelector(
    ditSliceSelectors.stateDitActiveProgram
  )
  const { refetch } = useGetDitsQuery(Number(id))

  const [modalSetDit, setModalSetDit] = React.useState(false)

  const hasUnsavedChanges = useAppSelector(ditSliceSelectors.stateHasChanges)
  const PList = useAppSelector(ditSliceSelectors.stateDitPrograms)

  const [copyDit, { isLoading: copyLoading }] = useCreateCopyProgramMutation()

  const handleCopy = async () => {
    setModalSetDit(true)
  }

  const approvedSend = async () => {
    const newId = getLastProgramNumber(PList)

    const name = `Программа ${newId}`
    const res = await copyDit({
      deviceId: Number(id),
      programId: activeProgramId || 0,
      name: name,
    })
    // @ts-ignore
    if (res?.data?.success) {
      notifySuccess(
        `Программа была удачно продублирована. Имя новой программы: ${name}`
      )
    }
    setModalSetDit(false)
    refetch()
  }

  return (
    <>
      <LoaderFullScreen open={copyLoading} />
      <DialogChanges
        open={modalSetDit}
        loading={copyLoading}
        handleAgree={approvedSend}
        handleClose={() => setModalSetDit(false)}
        handleDisAgree={() => setModalSetDit(false)}
        message={'Вы действительно желаете продублировать данную программу?'}
        btnSaveTitle={'Да'}
        btnCancelTitle={'Нет'}
      />
      <LoadingButton
        variant={'contained'}
        color='success'
        loading={false}
        onClick={handleCopy}
        disabled={hasUnsavedChanges}
      >
        Дублировать
      </LoadingButton>
    </>
  )
}

export default BtnMakeCopy
